import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Milliseconds } from '@iotv/datamodel-core';
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { ActionIcons } from '../../../Iconography';
import { NumericField } from '../../common/NumericField';
import { SingleEntityAutoQuery } from '../../generic/EntityAutoQuery';
export const Escalation = ({ escalation, setEscalation, contextObject, disabled }) => {
    const { afterDurationMs, recipient } = escalation;
    const [number, setNumber] = useState(afterDurationMs ? afterDurationMs / Milliseconds.HOUR : null);
    useEffect(() => {
        if (!isNonNaNNumber(number))
            return;
        escalation.afterDurationMs = number * Milliseconds.HOUR;
        setEscalation(escalation);
    }, [number]);
    return (_jsxs(Stack, { direction: "row", justifyContent: "center", gap: 1, children: [_jsx(Stack, { minWidth: "11em", children: _jsx(NumericField, { label: "Escalate after", fullWidth: true, disabled: disabled, error: afterDurationMs === undefined || number === null, value: afterDurationMs ? afterDurationMs / Milliseconds.HOUR : undefined, onChange: (n) => setNumber(n), slotProps: {
                        input: {
                            endAdornment: (_jsxs(InputAdornment, { position: "end", children: ["hour", (afterDurationMs ?? 0) / Milliseconds.HOUR === 1 ? '' : 's'] })),
                        },
                    } }) }), contextObject && (_jsx(SingleEntityAutoQuery, { contextObject: contextObject, currentEntity: recipient ?? null, setCurrentEntity: (recipient) => {
                    escalation.recipient = recipient ?? undefined;
                    setEscalation(escalation);
                }, label: "Escalate to", entityType: "User", fullWidth: true, required: true, disabled: disabled })), _jsx(IconButton, { color: "error", onClick: () => setEscalation(undefined), disabled: disabled, children: _jsx(ActionIcons.Delete, {}) })] }));
};
